import request from '@/util/request'

export const billDevices = (params) => {
  return request({
    url: '/api/v1/factory/bill/devices',
    method: 'get',
    params
  })
}

export const billAnalyze = (params) => {
  return request({
    url: '/api/v1/factory/bill/analyze',
    method: 'get',
    params
  })
}

export const billDailyList = (params) => {
  return request({
    url: '/api/v1/factory/bill/daily/list',
    method: 'get',
    params
  })
}

export const billDailyUnion = (params) => {
  return request({
    url: '/api/v1/factory/bill/daily/union',
    method: 'get',
    params
  })
}
